import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=3fa71f52&"
import script from "./qa.vue?vue&type=script&lang=js&"
export * from "./qa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa71f52')) {
      api.createRecord('3fa71f52', component.options)
    } else {
      api.reload('3fa71f52', component.options)
    }
    module.hot.accept("./qa.vue?vue&type=template&id=3fa71f52&", function () {
      api.rerender('3fa71f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qa.vue"
export default component.exports